import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/** «Map Base {Light}» ilustrativo (tokens map/*) con el «Map Pin {Selected}» del negocio al centro. Sin red. */
@Component({
  selector: 'app-map-art',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="park"></div>
    <div class="blocks">@for (b of blocks; track $index) { <i></i> }</div>
    <div class="avenue"></div>
    @if (showPin()) {
      <div class="pin">
        <span class="halo"><span class="ring"><app-business-logo [name]="name() || 'Tu negocio'" [url]="logoUrl()" [size]="52" [radius]="26" /></span></span>
        <span class="label">{{ name() || 'Tu negocio' }}</span>
        @if (check()) { <span class="check"><cr-icon name="check" [size]="18" /></span> }
      </div>
    } @else {
      <p class="none"><cr-icon name="pin" [size]="20" />Sin ubicación</p>
    }
  `,
  styles: [`
    :host{position:relative;display:block;overflow:hidden;background:var(--cr-map-street);border-radius:inherit}
    .park{position:absolute;left:0;top:0;width:31%;height:60%;background:var(--cr-map-park);border-radius:0 0 24px 0}
    .blocks{position:absolute;inset:0;display:grid;grid-template-columns:repeat(6,1fr);grid-template-rows:repeat(4,1fr);gap:14px;padding:0 0 0 33%}
    .blocks i{background:var(--cr-map-block);border-radius:4px}
    .avenue{position:absolute;left:-10%;right:-10%;top:58%;height:18px;background:var(--cr-map-street-major);transform:rotate(-28deg);box-shadow:0 0 0 1px rgb(0 0 0 / .03)}
    .pin{position:absolute;left:50%;top:50%;transform:translate(-50%,-62%);display:flex;flex-direction:column;align-items:center;gap:6px}
    .halo{width:84px;height:84px;border-radius:50%;background:rgb(10 92 90 / .16);display:grid;place-items:center}
    .ring{width:70px;height:70px;border-radius:50%;border:3px solid var(--cr-brand-teal);background:#fff;display:grid;place-items:center;box-shadow:var(--cr-elevation-3)}
    .label{padding:6px 12px;border-radius:999px;background:var(--cr-bg-inverse);color:#fff;font:600 13px/16px var(--cr-font-body);white-space:nowrap}
    .check{position:absolute;right:-6px;top:0;width:28px;height:28px;border-radius:50%;background:var(--cr-success);color:#fff;display:grid;place-items:center;border:3px solid #fff}
    .none{position:absolute;inset:0;margin:0;display:flex;align-items:center;justify-content:center;gap:8px;font:600 15px/22px var(--cr-font-body);color:var(--cr-text-secondary);background:rgb(244 245 247 / .7)}
  `],
})
export class MapArtComponent {
  readonly name = input<string>('');
  readonly logoUrl = input<string | null | undefined>(null);
  readonly showPin = input<boolean>(true);
  readonly check = input<boolean>(false);
  readonly blocks = Array.from({ length: 24 });
}
